import React, {Component} from 'react'
import AccountsPage from './AccountsPage'
import {_getListAccounts} from '../../../../services/apis/AccountServices'

class AccountsPageContainer extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: 1,
            limit: 100,
            maxPage: 1,
        },
        error: '',
        isModalOpen: false,
        modalData: {
            id: '',
            email: '',
            password: '',
            recoverPhone: '',
            recoverEmail: '',
            proxy: '',
            note: ''
        }
    }

    _refresh = null

    componentDidMount() {
        this._fetchAccountInfo()

        this._refresh = setInterval(() => {
            this._fetchAccountInfo()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _removeAccountFormState = (id) => {
        this.setState(({docs}) => ({docs: docs.filter(account => account._id !== id)}))
    }

    _fetchAccountInfo = () => {
        const {page, limit} = this.state.pagination

        _getListAccounts(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    _handleChangePage = (page) => {
        const {limit} = this.state.pagination

        this.setState(prevState => ({pagination: {...prevState.pagination, page}}))

        _getListAccounts(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _toggleModal = () => {
        this.setState(({isModalOpen}) => ({
            isModalOpen: !isModalOpen
        }))
    }

    _closeModal = () => {
        this.setState({
            isModalOpen: false,
        })
    }

    _changeModalData = (modalData) => {
        this.setState({
            modalData,
        })
    }

    _handleUpdateListAccounts = ({id, email, password, recoverEmail, recoverPhone, proxy}) => {
        this.setState(({docs}) => ({
            docs: docs.map(account => {
                if (account._id !== id) {
                    return account
                }
                return {
                    ...account,
                    email,
                    password,
                    recoverEmail,
                    recoverPhone,
                    proxy
                }
            })
        }))
    }

    render() {
        const {isModalOpen, modalData} = this.state

        return (
            <AccountsPage {...this.state} onChangePage={this._handleChangePage}
                          onRefreshPage={this._fetchAccountInfo}
                          removeAccountFormState={this._removeAccountFormState}
                          onToggleModal={this._toggleModal}
                          onCloseModal={this._closeModal}
                          onChangeModalData={this._changeModalData}
                          isModalOpen={isModalOpen}
                          modalData={modalData}
                          onUpdateListAccounts={this._handleUpdateListAccounts}/>
        )
    }

}

export default AccountsPageContainer


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/AccountsPageContainer.js